import { SelectV2 } from '../../../Fields';

const hours = [
  '00' as const,
  '01' as const,
  '02' as const,
  '03' as const,
  '04' as const,
  '05' as const,
  '06' as const,
  '07' as const,
  '08' as const,
  '09' as const,
  '10' as const,
  '11' as const,
  '12' as const,
  '13' as const,
  '14' as const,
  '15' as const,
  '16' as const,
  '17' as const,
  '18' as const,
  '19' as const,
  '20' as const,
  '21' as const,
  '22' as const,
  '23' as const,
  '24' as const,
];

const without24 = hours.slice(0, -1);

type Hour = (typeof hours)[number];

interface TimeSelectionProps {
  readonly isEnd?: boolean;
  readonly name?: string;
  readonly hour?: Hour;
  readonly exclude24?: boolean;
  readonly disabled?: boolean;
  readonly onChangeHour?: (hour: Hour) => void;
}

function TimeSelection({ name, hour, disabled, isEnd, exclude24, onChangeHour }: TimeSelectionProps) {
  return (
    <SelectV2 name={name} disabled={disabled} defaultValue={isEnd ? '24' : hour || '07'} placeholder="-" onChange={onChangeHour}>
      {(exclude24 ? without24 : hours).map((h) => (
        <SelectV2.Option key={h} value={h}>
          {`${h}:00`}
        </SelectV2.Option>
      ))}
    </SelectV2>
  );
}

export { TimeSelection, hours };
